export default "__VITE_ASSET__DBbZEWNS__"